import React from 'react'
import {Consumer} from '../../context'
import Courses from '../../components/my-courses'
import Units from '../../components/units'
import './my-courses.styl'

const views = {
  courses: Courses,
  units: Units
}

export default function MyCourses () {
  return (
    <Consumer>{ (context) => {
      const view = /\/..\/.+\/my-courses$/.test(context.match.url) ? 'courses' : 'units'
      const View = views[view]
      return <div><View /></div>
    }}</Consumer>
  );
}

